
















import Vue from 'vue'
import { DataTreeNode } from '@/utils/array'
import {
  WorkStationBatchBoundCalendarDTO,
  WorkStationServiceProxy
} from "@/service-proxies/app-v2/workStation.service-proxies";
const wsgsp = new WorkStationServiceProxy()
export default Vue.extend({
  data(){
    return {
      workStatoinItems:[],
      expendKeys: [],
      checkedKeys:[],
      treeData: []
    }
  },
  props:{
    calendar:{
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    'calendar':{
      handler(oldVal,newVal){
        if(oldVal && oldVal.code !== undefined && oldVal.code !== ''){
          this.getList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    getList(){
      this.treeData = []
      this.workStatoinItems = []
      this.expendKeys = []
      this.checkedKeys = []
      wsgsp.noCalendarBoundWorkStation(this.calendar.code).then(res =>{
        if(res){
          const data = res.reduce((total, value) =>{
            const key = value.id + '-' + value.parentId
            total.push({
              ...value,
              key: key
              })
              if(!value.isWorkStation){
                this.expendKeys.push(key)
              }
            return total
          }, [])
          this.treeData = DataTreeNode.arrayTree(data);
          this.workStatoinItems = data
        }
      })
    },
    onSelect(value){
      this.checkedKeys = value
    },
    onExpand(value){
      this.expendKeys = value
    },
    save(){
      const value = this.setWorkStationList()
      if(value.length === 0){
        this.$message.error('请选择工位');
        return false
      }
      const data = {
        waitingUpdateCalendar: this.calendar.code,
        workStationId: value
      } as WorkStationBatchBoundCalendarDTO
      wsgsp.calendarBoundWorkStation(data).then(() =>{
        this.$message.success('绑定成功')
      })
      return true
    },
    addKeyId(item){
      const key = item.id + '-' + item.parentId
      return key
    },
    setWorkStationList(){
      const recheckKeys = []
      this.workStatoinItems.map(res =>{
        if(this.checkedKeys.includes(this.addKeyId(res)) && !recheckKeys.includes(res.id) && !res.isGroup){
          recheckKeys.push(res.id)
        }
      })
      return recheckKeys
    },
  }
})
